<template>
  <div class="col-md-12">
    <div class="title-heading d-flex justify-content-between">
      <h1>{{$static('s-m.title', 'Стартове повідомлення')}}</h1>
    </div>
    <MessageTemplateEditor :title="$static('msg.tlt', 'Створення повідомлення')" :name="'start_message'"></MessageTemplateEditor>

  </div>
</template>

<script>
  import api from '@/api'
  import MessageTemplateEditor from '../components/MessageTemplateEditor';

  export default {
    name    : 'SettingsMessage',
    components: {MessageTemplateEditor},
    data() {
      return {

      }
    },
  }
</script>

<style scoped>

</style>